<template>
<div class="chapter">
<div class="inner_page">
<p><a id="toc"></a></p>
<div class="fmh1">Table of Contents</div>
<div> <br/></div>
<div class="cfmh"><a href="#/daci_9781558617834_oeb_fm1_r1">Praise</a></div>
<div class="cfmh"><span href="#/daci_9781558617834_oeb_tp_r1" title="Link target outside of Sample">Title Page</span></div>
<div class="cfmh"><a href="#/daci_9781558617834_oeb_fm2_r1">The Ucrìas a family tree</a></div>
<div> <br/></div>
<div class="cct"><a href="#/daci_9781558617834_oeb_c01_r1">I</a></div>
<div class="cct"><a href="#/daci_9781558617834_oeb_c02_r1">II</a></div>
<div class="cct"><a href="#/daci_9781558617834_oeb_c03_r1">III</a></div>
<div class="cct"><a href="#/daci_9781558617834_oeb_c04_r1">IV</a></div>
<div class="cct"><a href="#/daci_9781558617834_oeb_c05_r1">V</a></div>
<div class="cct"><a href="#/daci_9781558617834_oeb_c06_r1">VI</a></div>
<div class="cct"><a href="#/daci_9781558617834_oeb_c07_r1">VII</a></div>
<div class="cct"><span href="#/daci_9781558617834_oeb_c08_r1" title="Link target outside of Sample">VIII</span></div>
<div class="cct"><span href="#/daci_9781558617834_oeb_c09_r1" title="Link target outside of Sample">IX</span></div>
<div class="cct"><span href="#/daci_9781558617834_oeb_c10_r1" title="Link target outside of Sample">X</span></div>
<div class="cct"><span href="#/daci_9781558617834_oeb_c11_r1" title="Link target outside of Sample">XI</span></div>
<div class="cct"><span href="#/daci_9781558617834_oeb_c12_r1" title="Link target outside of Sample">XII</span></div>
<div class="cct"><span href="#/daci_9781558617834_oeb_c13_r1" title="Link target outside of Sample">XIII</span></div>
<div class="cct"><span href="#/daci_9781558617834_oeb_c14_r1" title="Link target outside of Sample">XIV</span></div>
<div class="cct"><span href="#/daci_9781558617834_oeb_c15_r1" title="Link target outside of Sample">XV</span></div>
<div class="cct"><span href="#/daci_9781558617834_oeb_c16_r1" title="Link target outside of Sample">XVI</span></div>
<div class="cct"><span href="#/daci_9781558617834_oeb_c17_r1" title="Link target outside of Sample">XVII</span></div>
<div class="cct"><span href="#/daci_9781558617834_oeb_c18_r1" title="Link target outside of Sample">XVIII</span></div>
<div class="cct"><span href="#/daci_9781558617834_oeb_c19_r1" title="Link target outside of Sample">XIX</span></div>
<div class="cct"><span href="#/daci_9781558617834_oeb_c20_r1" title="Link target outside of Sample">XX</span></div>
<div class="cct"><span href="#/daci_9781558617834_oeb_c21_r1" title="Link target outside of Sample">XXI</span></div>
<div class="cct"><span href="#/daci_9781558617834_oeb_c22_r1" title="Link target outside of Sample">XXII</span></div>
<div class="cct"><span href="#/daci_9781558617834_oeb_c23_r1" title="Link target outside of Sample">XXIII</span></div>
<div class="cct"><span href="#/daci_9781558617834_oeb_c24_r1" title="Link target outside of Sample">XXIV</span></div>
<div class="cct"><span href="#/daci_9781558617834_oeb_c25_r1" title="Link target outside of Sample">XXV</span></div>
<div class="cct"><span href="#/daci_9781558617834_oeb_c26_r1" title="Link target outside of Sample">XXVI</span></div>
<div class="cct"><span href="#/daci_9781558617834_oeb_c27_r1" title="Link target outside of Sample">XXVII</span></div>
<div class="cct"><span href="#/daci_9781558617834_oeb_c28_r1" title="Link target outside of Sample">XXVIII</span></div>
<div class="cct"><span href="#/daci_9781558617834_oeb_c29_r1" title="Link target outside of Sample">XXIX</span></div>
<div class="cct"><span href="#/daci_9781558617834_oeb_c30_r1" title="Link target outside of Sample">XXX</span></div>
<div class="cct"><span href="#/daci_9781558617834_oeb_c31_r1" title="Link target outside of Sample">XXXI</span></div>
<div class="cct"><span href="#/daci_9781558617834_oeb_c32_r1" title="Link target outside of Sample">XXXII</span></div>
<div class="cct"><span href="#/daci_9781558617834_oeb_c33_r1" title="Link target outside of Sample">XXXIII</span></div>
<div class="cct"><span href="#/daci_9781558617834_oeb_c34_r1" title="Link target outside of Sample">XXXIV</span></div>
<div class="cct"><span href="#/daci_9781558617834_oeb_c35_r1" title="Link target outside of Sample">XXXV</span></div>
<div class="cct"><span href="#/daci_9781558617834_oeb_c36_r1" title="Link target outside of Sample">XXXVI</span></div>
<div class="cct"><span href="#/daci_9781558617834_oeb_c37_r1" title="Link target outside of Sample">XXXVII</span></div>
<div class="cct"><span href="#/daci_9781558617834_oeb_c38_r1" title="Link target outside of Sample">XXXVIII</span></div>
<div class="cct"><span href="#/daci_9781558617834_oeb_c39_r1" title="Link target outside of Sample">XXXIX</span></div>
<div class="cct"><span href="#/daci_9781558617834_oeb_c40_r1" title="Link target outside of Sample">XL</span></div>
<div class="cct"><span href="#/daci_9781558617834_oeb_c41_r1" title="Link target outside of Sample">XLI</span></div>
<div class="cct"><span href="#/daci_9781558617834_oeb_c42_r1" title="Link target outside of Sample">XLII</span></div>
<div class="cct"><span href="#/daci_9781558617834_oeb_c43_r1" title="Link target outside of Sample">XLIII</span></div>
<div> <br/></div>
<div class="cbmh"><span href="#/daci_9781558617834_oeb_afw_r1" title="Link target outside of Sample">Afterword</span></div>
<div class="cbmh"><span href="#/daci_9781558617834_oeb_nts_r1" title="Link target outside of Sample">Notes</span></div>
<div class="cbmh"><span href="#/daci_9781558617834_oeb_cop_r1" title="Link target outside of Sample">Copyright Page</span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// daci_9781558617834_oeb_toc_r1.vue?1da3bc08